import { BrandStory } from './body/brand-story/BrandStory';
import { Customer } from './body/customer/Customer';
import { Download } from './download/Download';
import { Philosophy } from './philosophy/Philosophy';
import { Matching } from './matching/Matching';
import { Epyt } from './epyt/Epyt';
import { Definition } from './body/Definition';
import { Creator } from './body/creator/Creator';
import { Brand } from './body/brand/Brand';
import { Pouch } from './body/pouch/Pouch';
import { Header, headers } from './layout/header/Header';
import { Footer } from './layout/footer/Footer';

export const Main = () => {
    return (
        <div className="w-full h-full flex flex-col items-center justify-center overflow-x-hidden">
            <Header />
            <Epyt />
            <Philosophy />

            <section
                id={headers[2].id}
                className="w-full h-full flex flex-col xl:flex-row items-start justify-center pt-[500px]"
            >
                <Definition />

                <article className="w-full flex-1 min-w-0 h-full flex flex-col items-center justify-center">
                    <BrandStory />
                    <Customer />
                    <Creator />
                    <Brand />
                </article>
            </section>

            <Pouch />
            <Matching />

            <Download />
            <Footer />
        </div>
    );
};
